<script>
	import { onMount } from "svelte";
	import { browser } from "$app/environment";

	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCloudSunRain } from "@fortawesome/free-solid-svg-icons";

	import {
		getCurrentLocation,
		getGeoPermission,
	} from "$lib/utilities/geo.js";

	import { watchWeather } from "$lib/utilities/weatherStore.js";

	import MarkedContent from "./MarkedContent.svelte";

	export let icon;
	export let description;
	export let temp;
	export let details;

	let pos = null;
	let perm = "unknown";

	async function requestOnce() {
		try {
			pos = await getCurrentLocation(); // triggers the prompt if needed

			watchWeather(pos);
		} catch (e) {}
	}

	onMount(async () => {
		if (!browser) return; // SSR guard
		perm = (await getGeoPermission()) ?? "unknown";
		if (perm === "granted") {
			requestOnce();
		}
	});

	const enableWeather = (e) => {
		e.preventDefault();
		requestOnce();
	};
</script>

<li class="flex my-auto" id="main-app-weather">
	<div class="group relative">
		{#if pos}
			<div class="flex">
				<div class="">
					{#if icon && description}
						<img
							width="25"
							height="25"
							src={icon}
							alt={description}
						/>
					{/if}
				</div>
				<div class="flex flex-col justify-between">
					{#if typeof temp === "number"}
						<div class="">{Math.round(temp)}°F</div>
					{/if}
				</div>
			</div>

			<!-- Tooltip -->
			{#if icon && description && typeof temp === "number"}
				<div
					class="absolute -left-64 hidden group-hover:block bg-base-300 text-sm text-base-content p-2 rounded shadow-lg"
				>
					<MarkedContent markedContent={details} />
				</div>
			{/if}
		{:else}
			<button
				class="btn btn-sm flex gap-2 transition-all duration-300"
				aria-label="Enable weather updates"
				onclick={enableWeather}
			>
				<SvelteFa icon={faCloudSunRain} size="1.5x" />
			</button>
			<div
				class="absolute -left-64 hidden group-hover:block bg-base-300 text-sm text-base-content p-2 rounded shadow-lg"
			>
				<MarkedContent
					markedContent={"Click here to get the current weather"}
				/>
			</div>
		{/if}
	</div>
</li>
